import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ApiStatusType, СlosestDatesStateType } from './types';

const initialState: СlosestDatesStateType = {
  status: null,
  result: [],
};

const closestDatesSlice = createSlice({
  name: 'closestDates',
  initialState,
  reducers: {
    setStatusAction: (
      state: СlosestDatesStateType,
      action: PayloadAction<ApiStatusType>,
    ) => {
      state.status = action.payload;
    },
    setDataAction: (
      state: СlosestDatesStateType,
      action: PayloadAction<СlosestDatesStateType['result']>,
    ) => {
      state.result = action.payload;
    },
  },
});

export const { setStatusAction, setDataAction } = closestDatesSlice.actions;
export const closestDatesReducer = closestDatesSlice.reducer;
